import { useTranslation } from 'react-i18next';

import * as S from './style';

const businessItemKeys = [
	'introduce.owner.business.research',
	'introduce.owner.business.events',
	'introduce.owner.business.publications',
	'introduce.owner.business.tours',
	'introduce.owner.business.awards',
	'introduce.owner.business.exchange',
	'introduce.owner.business.education',
	'introduce.owner.business.other',
] as const;

const planItemKeys = ['introduce.owner.plan.internationalJournal', 'introduce.owner.plan.scopus', 'introduce.owner.plan.integratedJournal'] as const;

const IntroduceOwner = () => {
	const { t } = useTranslation();

	return (
		<S.IntroduceOwnerContainer>
			<S.OwnerContentBox>
				<S.OwnerTitleBox>
					<S.OwnerTitle>{t('introduce.owner.title')}</S.OwnerTitle>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.name')}</S.OwnerSubTitle>
						<S.OwnerDescription>{t('introduce.owner.nameValue')}</S.OwnerDescription>
					</S.OwnerContentMenuBox>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.location')}</S.OwnerSubTitle>
						<S.OwnerDescription>
							{t('introduce.owner.location.address')}
							<br />
							{t('introduce.owner.location.phone')}
							<br />
							{t('introduce.owner.location.homepage')}
							<br />
							{t('introduce.owner.location.email')}
						</S.OwnerDescription>
					</S.OwnerContentMenuBox>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.about')}</S.OwnerSubTitle>
						<S.OwnerDescription>{t('introduce.owner.about.description')}</S.OwnerDescription>
					</S.OwnerContentMenuBox>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.purpose')}</S.OwnerSubTitle>
						<S.OwnerDescription>{t('introduce.owner.purpose.paragraph1')}</S.OwnerDescription>
						<S.OwnerDescription>{t('introduce.owner.purpose.paragraph2')}</S.OwnerDescription>
						<S.OwnerDescription>{t('introduce.owner.purpose.paragraph3')}</S.OwnerDescription>
					</S.OwnerContentMenuBox>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.business')}</S.OwnerSubTitle>
						{businessItemKeys.map((key) => (
							<S.OwnerDescription key={key}>{t(key)}</S.OwnerDescription>
						))}
					</S.OwnerContentMenuBox>

					<S.OwnerContentMenuBox>
						<S.OwnerSubTitle>{t('introduce.owner.sections.plan')}</S.OwnerSubTitle>
						<S.OwnerDescription>{t('introduce.owner.plan.paragraph1')}</S.OwnerDescription>
						<S.OwnerDescription>{t('introduce.owner.plan.paragraph2')}</S.OwnerDescription>
						{planItemKeys.map((key) => (
							<S.OwnerDescription key={key}>- {t(key)}</S.OwnerDescription>
						))}
					</S.OwnerContentMenuBox>
				</S.OwnerTitleBox>
			</S.OwnerContentBox>
		</S.IntroduceOwnerContainer>
	);
};

export default IntroduceOwner;
